import type { IconConfig } from '../types'

export interface ShapeEmitter {
  move: (x: number, y: number) => void
  line: (x: number, y: number) => void
  arc: (cornerX: number, cornerY: number, endX: number, endY: number, radius: number) => void
  close?: () => void
}

export function walkShape(
  centerX: number,
  centerY: number,
  halfSize: number,
  corners: IconConfig['corners'],
  emitter: ShapeEmitter,
) {
  const left = centerX - halfSize
  const right = centerX + halfSize
  const top = centerY - halfSize
  const bottom = centerY + halfSize

  const radiusTL = corners.tl ? halfSize : 0
  const radiusTR = corners.tr ? halfSize : 0
  const radiusBR = corners.br ? halfSize : 0
  const radiusBL = corners.bl ? halfSize : 0

  emitter.move(left + radiusTL, top)
  emitter.line(right - radiusTR, top)

  if (radiusTR > 0) {
    emitter.arc(right, top, right, top + radiusTR, radiusTR)
  }

  emitter.line(right, bottom - radiusBR)

  if (radiusBR > 0) {
    emitter.arc(right, bottom, right - radiusBR, bottom, radiusBR)
  }

  emitter.line(left + radiusBL, bottom)

  if (radiusBL > 0) {
    emitter.arc(left, bottom, left, bottom - radiusBL, radiusBL)
  }

  emitter.line(left, top + radiusTL)

  if (radiusTL > 0) {
    emitter.arc(left, top, left + radiusTL, top, radiusTL)
  }

  emitter.close?.()
}
